import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE_URL = "https://wexoz.com";

const setMeta = (selector, attrs) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(selector.startsWith("link") ? "link" : "meta");
    Object.entries(attrs).forEach(([k, v]) => k !== "content" && k !== "href" && el.setAttribute(k, v));
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
};

export const useSEO = ({ title, description, image = "/og-image.jpg", jsonLd, type = "website", noindex = false }) => {
  const { pathname } = useLocation();
  useEffect(() => {
    const url = `${SITE_URL}${pathname === "/" ? "" : pathname}`;
    const img = image?.startsWith("http") ? image : `${SITE_URL}${image}`;
    document.title = title;
    setMeta('meta[name="robots"]', { name: "robots", content: noindex ? "noindex, follow" : "index, follow" });
    setMeta('meta[property="og:type"]', { property: "og:type", content: type });
    if (description) {
      setMeta('meta[name="description"]', { name: "description", content: description });
      setMeta('meta[property="og:description"]', { property: "og:description", content: description });
      setMeta('meta[name="twitter:description"]', { name: "twitter:description", content: description });
    }
    setMeta('meta[property="og:title"]', { property: "og:title", content: title });
    setMeta('meta[name="twitter:title"]', { name: "twitter:title", content: title });
    setMeta('meta[property="og:url"]', { property: "og:url", content: url });
    setMeta('meta[property="og:image"]', { property: "og:image", content: img });
    setMeta('meta[name="twitter:image"]', { name: "twitter:image", content: img });
    setMeta('meta[name="twitter:card"]', { name: "twitter:card", content: "summary_large_image" });
    setMeta('link[rel="canonical"]', { rel: "canonical", href: url });

    const old = document.getElementById("page-jsonld");
    if (old) old.remove();
    if (jsonLd) {
      const s = document.createElement("script");
      s.id = "page-jsonld";
      s.type = "application/ld+json";
      s.text = JSON.stringify(jsonLd);
      document.head.appendChild(s);
    }
  }, [title, description, image, jsonLd, pathname, type, noindex]);
};
